// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__30u1_","subheader":"ReorderModal_subheader__2Gho5","listWrap":"ReorderModal_listWrap__3Ncpd"};